module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flash-back-findx2.bf0ce37f.png";